export default "__VITE_ASSET__CdAv1IgC__"